import {Dispatch} from "redux";

import {catch404} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";

import {IOfferDetailApplication} from "../../offer/types/IOfferDetailApplication";
import {getApplicationOfferDetailById} from "../api/get_application_offer_detail_by_id";

const APPLICATION_OFFER_DETAIL_PREFIX = "desktop/application/offer_detail/fetch";
export const getApplicationOfferDetailTypes = createRequestActionTypes(APPLICATION_OFFER_DETAIL_PREFIX);

export const getApplicationOfferDetail =
    (offerId: number, applicationId: string) =>
    (dispatch: Dispatch): Promise<IOfferDetailApplication | void> => {
        dispatch({type: getApplicationOfferDetailTypes.start, id: applicationId});

        return getApplicationOfferDetailById(offerId)
            .then((json) => {
                dispatch({type: getApplicationOfferDetailTypes.success, id: applicationId, result: json});
                return json;
            })
            .catch(
                catch404(() => {
                    dispatch({type: getApplicationOfferDetailTypes.error, id: applicationId});
                })
            );
    };
import {Dispatch} from "redux";

import {catch404} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";

import {IOfferDetailApplication} from "../../offer/types/IOfferDetailApplication";
import {getApplicationOfferDetailById} from "../api/get_application_offer_detail_by_id";

const APPLICATION_OFFER_DETAIL_PREFIX = "desktop/application/offer_detail/fetch";
export const getApplicationOfferDetailTypes = createRequestActionTypes(APPLICATION_OFFER_DETAIL_PREFIX);

export const getApplicationOfferDetail =
    (offerId: number, applicationId: string) =>
    (dispatch: Dispatch): Promise<IOfferDetailApplication | void> => {
        dispatch({type: getApplicationOfferDetailTypes.start, id: applicationId});

        return getApplicationOfferDetailById(offerId)
            .then((json) => {
                dispatch({type: getApplicationOfferDetailTypes.success, id: applicationId, result: json});
                return json;
            })
            .catch(
                catch404(() => {
                    dispatch({type: getApplicationOfferDetailTypes.error, id: applicationId});
                })
            );
    };
